<ng-container>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Preview Document</h5>
  </div>
  <div class="modal-body" ngbAutofocus>
    <div>
      <ngx-doc-viewer *ngIf="documentBase64URL && !loading"
        [url]="documentBase64URL"
        [viewer]="whichViewer"
      ></ngx-doc-viewer>
      <span
        *ngIf="loading"
        aria-hidden="true"
        class="spinner-border spinner-border-sm"
        role="status"
      >
      </span>
      <p *ngIf="!loading && !ok">
        Error loading document! Check console for details.
      </p>
    </div>
  </div>
  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="close()">
      Close
    </button>
  </div>
</ng-container>
